import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'

import IsometricHero from '../components/main/hero_vector'
import Button from '../components/buttons/Button'
import Banner from '../components/banner'
import CloudBedsButton from '../components/buttons/CloudBedsButton'
import LearnAboutCloudBedsButton from '../components/buttons/LearnAboutCloudBedsButton'
import Card from '../components/card'
import Section from '../components/section'

import WhistleLogo from '../assets/Logo.png'
import CloudbedsLogo from '../assets/cloudbeds-logo.png'
import CloudBedsExample from '../assets/cloudbeds-example.png'

const Page = styled.div`

`

const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: 1025px) {
    flex-direction: row;
	}
`

const HeroSubheader = styled.h2`
  font-size: 1rem;
  font-weight: 500;
  font-family: 'Roboto';
  line-height: 1.5rem;
  align-self: flex-start;
  @media (min-width: 1025px) {
    font-size: 1.5rem;
    align-self: center;
	}
`

const HeaderWrapper = styled.div`
  flex: 2 400px;
  margin-top: 1rem;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  h2 {
    text-align: left;
  }
  ul {
    list-style-type: none;
    margin: 2rem 0;
    li {
      padding: 0.2rem 0;
    }
  }
  @media (min-width: 1025px) {
    margin-top: 0;
	}
`

const SectionHeader = styled.h3`
  text-align: center;
  font-size: 36px;
  font-weight: bold;
`

const PartnerBox = styled.div`
  display: flex;
  margin-bottom: 2rem;
  flex-direction: row;
  padding: 0 3rem;
  align-items: center;
  img {
    margin: 1rem;
    max-width: 160px;
    max-height: 55px;
  }
`

const VectorWrapper = styled.div`
  flex: 3 280px;
  margin-top: 1rem;
  @media (min-width: 1025px) {
    padding: 1rem;
    align-self: center;
	}
`

const Demo = styled.div`
  img {
    display: block;
    margin: 5rem auto;
    width: 80%;
  }
`

const redirectURI = encodeURIComponent('https://gze6w2ai62.execute-api.us-west-2.amazonaws.com/prod/cloudbeds/oauth_code')
const clientId = encodeURIComponent('whistle_C8Wua1y63JAXMwqmUr0cieh2')
const scope = 'read%3Aguest+read%3Ahotel+read%3Areservation+read%3Aroom'
const url = `https://hotels.cloudbeds.com/api/v1.1/oauth?client_id=${clientId}&redirect_uri=${redirectURI}&response_type=code&scope=${scope}`

const item = {
  partner: `If you're already using Cloudbeds for your PMS, adding Whistle is a no-brainer`,
  description: `Approximately 40% of hotel rooms are booked using a mobile device.  Five years ago, it was about 10%.  If you look at the data, guests are showing a strong preference for conducting all hotel interactions through their smartphone.  Not just booking a hotel room, but paying their bill, ordering room service, even notifying staff that they need more towels.  

  So the predicament we found ourselves in as a hotel operator was: How do we deliver a modern digital customer experience while maintaining a traditional hotel appearance? Whistle solves this issue because it takes the guest texting off the iPhone and puts it on the front desk computer.  Front desk staff are able to efficiently respond to guests' texts while appearing to guests to be on-task and in-service.
  
  Furthermore, with the Cloudbeds/Whistle integration, the management of the digital guest experience is even more seamless and easy to manage.  Guest phone numbers and stay dates are passed from Cloudbeds into Whistle so we can automate the entire process.  Text messages can be triggered at different points in their stay.  For example, 3-minutes after our front desk staff has changed the guest's status to IN-HOUSE, the guest receives text message making sure they like their room.  We don't even have to think about it.  We can also trigger texts to be sent at check-out to ask for a review.
  
  If you're already using Cloudbeds for your PMS, adding Whistle is a no-brainer.  It's the simplest and most efficient way to respond to the needs of the modern traveler.  Ask yourself this, "will guests be more likely to communicate via text message this upcoming year than in the previous year?"  The obvious answer is "yes."  So why not go with the obvious solution now`,
  author: 'Brendam Bauman, Fieldhouse Jones'
}

const CloudBeds = (props) => {
  return (
    <Page>
      <Banner
        link={url}
        text={'Cloudbeds Customers Receive a Discount When Integrating!'}
      />
      <HeroWrapper>
        <HeaderWrapper>
          <PartnerBox>
            <img src={WhistleLogo} />
            <h3>+</h3>
            <img src={CloudbedsLogo} />
          </PartnerBox>
          <HeroSubheader>The #1 Hospitality Software meets</HeroSubheader>
          <HeroSubheader>The #1 Guest Messaging Messaging Platform</HeroSubheader>

          <ul>
            <li>- Automated Guest Messaging</li>
            <li>- Powerful In-Stay Surveys</li>
            <li>- Team Messaging</li>
          </ul>

          <CloudBedsButton />
          <br/>
          <LearnAboutCloudBedsButton />
        </HeaderWrapper>
        <VectorWrapper>
          <IsometricHero />
        </VectorWrapper>
      </HeroWrapper>
      <Section id="how-it-works" animated light>
        <SectionHeader>Testimonials</SectionHeader>
        <Card item={item} />
      </Section>
      <Demo>
        <img src={CloudBedsExample} />
      </Demo>
    </Page>
  )
}
 
export default CloudBeds;


// WEBPACK FOOTER //
// ./src/pages/cloudbeds.js